import http from "../helpers/http-common";

class StatsDataService {
    getUsersAgeStats(params) {
        return http.get("/stats/usersAge", { params });
    }
    getUsersGenderStats(params) {
        return http.get("/stats/usersGender", { params });
    }
    getUsersGenderTodayStats(params) {
        return http.get("/stats/usersGenderToday", { params });
    }
    getUsersCountryStats(params) {
        return http.get("/stats/usersCountries", { params });
    }
    getUsersRegisterStats(params) {
        return http.get("/stats/usersRegister", { params });
    }
    getUsersEmailProvidersStats(params) {
        return http.get("/stats/usersEmailProvider", { params });
    }
    getUsersVideosStats(params) {
        return http.get("/stats/usersVideos", { params });
    }
    getLikesStats(params) {
        return http.get("/stats/likes", { params });
    }
    getUsersConnections(params) {
        return http.get("/stats/usersConnections", { params });
    }

    getUsersConnectionsGender(params) {
        return http.get("/stats/usersConnectionsGender", { params });
    }

    getUsersConnectionsCountry(params) {
        return http.get("/stats/usersConnectionsCountry", { params });
    }

    getUsersConnectionsAdSource(params) {
        return http.get("/stats/usersConnectionsAdSource", { params });
    }

    getUsersConnectionsAppVersion(params) {
        return http.get("/stats/usersConnectionsAppVersion", { params });
    }

    getMessagesGender(params) {
        return http.get("/stats/messagesGender", { params });
    }

    getMessagesCountry(params) {
        return http.get("/stats/messagesCountry", { params });
    }

    getChatRoomsCountry(params) {
        return http.get("/stats/chatRoomsCountry", { params });
    }

    getUsersTokens(params) {
        return http.get("/stats/usersTokens", { params });
    }
}

export default new StatsDataService();
